import { render, staticRenderFns } from "./groups-actions-column.vue?vue&type=template&id=ca1bc70c"
import script from "./groups-actions-column.vue?vue&type=script&lang=js"
export * from "./groups-actions-column.vue?vue&type=script&lang=js"
import style0 from "./groups-actions-column.vue?vue&type=style&index=0&id=ca1bc70c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports